import {useCallback, useMemo} from 'react'
import {useLocation, useSearchParams as useRouterSearchParams} from 'react-router'

export const useSearchParams = <P extends string, V extends Record<P, string | null>>(
  ...paramNames: P[]
): [V, (newValues: V) => void] => {
  const {pathname, search} = useLocation()
  const [obtainedSearchParams, setRouterSearchParams] = useRouterSearchParams()

  const obtainedValues = useMemo(
    () =>
      paramNames.reduce(
        (acc, paramName) => {
          const value = obtainedSearchParams.get(paramName)
          acc[paramName] = value
          return acc
        },
        {} as Record<P, string | null>
      ),
    [paramNames, obtainedSearchParams]
  )

  const setSearchParams = useCallback(
    (params: Record<P, string | null>) => {
      setRouterSearchParams(
        (URLSearchParams) => {
          Object.entries(params).map(([name, value]) => {
            if (value === null) URLSearchParams.delete(name)
            else URLSearchParams.set(name, value as string)
          })
          return URLSearchParams
        },
        {flushSync: true}
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname, search]
  )

  return [obtainedValues as V, setSearchParams]
}
